import React from 'react';
import '../styles/SocialProof.css';

function SocialProof() {
  return (
    <section className="social-proof">
      <div className="section-container">
        <div className="testimonial-card">
          <img
            src="/Zella flower shape@3x.png"
            alt=""
            aria-hidden="true"
            className="testimonial-flower"
          />
          <div className="testimonial-avatar">
            <img src="/jb.png" alt="Jon Berry" />
          </div>
          <div className="testimonial-content">
            <div className="testimonial-stars">
              {[1, 2, 3, 4, 5].map((i) => <span key={i}>★</span>)}
            </div>
            <p className="testimonial-quote">
              "Zella has allowed us to gain valuable insights into the wellbeing of our employees and tangible data surrounding our productivity schemes, including the transition to a four day work week."
            </p>
            <div className="testimonial-name">Jon Berry, Managing Director</div>
            <div className="testimonial-company">Tyler Grange</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialProof;
